module.exports = __webpack_public_path__ + "static/img/australia_a_league.d9b087d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/australia_a_league.png
// module id = MZG/
// module chunks = 1